import { render, staticRenderFns } from "./auth_distributor.vue?vue&type=template&id=650f074e"
import script from "./auth_distributor.vue?vue&type=script&lang=js"
export * from "./auth_distributor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports